import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { getTableCells, methodResult, responseType } from '../../../utils/TableCells';
import { actions } from '../../modules/Actions';
import { addRowTotalAndColumnTotal, columnDisps, columnKeys, rowData, TableDataProps } from '../../../utils/NegotiationReducerUtils';
import { getReportTableRowKeys } from '../ReportTableRowReducer';
import _isEqual from 'lodash/isEqual';
import moment from 'moment';

export const pendingViewColumns = [
  ['3rdMonth', '--年--月予定'],
  ['4thMonth', '--年--月予定'],
  ['5thMonth', '--年--月予定'],
  ['restoration', '復活予定'],
  ['total', '合計'],
];

export function xMonthLator(yyyyMMdd: string, monthLator: number): string {
  return moment(yyyyMMdd).add(monthLator, 'month').format('YYYY年M月予定');
}

export const pendingInitialState: TableDataProps = {
  // Stateの初期値
  header: columnKeys(pendingViewColumns),
  headerDisp: columnDisps(pendingViewColumns),
  data: rowData(),
};

function makingTableData(dtoToViewTable: methodResult, viewRow: string[]) {
  return {
    header: pendingInitialState.header,
    headerDisp: pendingInitialState.headerDisp,
    data: addRowTotalAndColumnTotal(dtoToViewTable, viewRow),
  };
}

export function convertViewColumns(headerDisp:{ [key: string]: string }):string[][]{
  const viewColumns = [];
  for(let key in headerDisp){
    viewColumns.push([key,headerDisp[key]]);
  }
  return viewColumns;
}

export const NegotiationPendingReducer = reducerWithInitialState(pendingInitialState)
.case(
  actions.updateNegotiation.pending,
  (state: TableDataProps, payload: responseType) => {
    const rowKeys = getReportTableRowKeys();
    const viewRowWithoutTotal = rowKeys.slice(1);
    const viewColumnsWithoutTotal = columnKeys(pendingViewColumns).slice(0, -1);
    const tableCells = getTableCells(payload, viewColumnsWithoutTotal, viewRowWithoutTotal);
    const newState = makingTableData(tableCells, viewRowWithoutTotal);

    return _isEqual(state.data, newState.data) ? state : newState;
  }
).case(
  actions.updateNegotiation.pendingHeaderDisp,
  (state: TableDataProps, payload: string) => {
    const newState = {header:[...state.header],headerDisp:{...state.headerDisp},data:{...state.data}};
    newState.headerDisp['3rdMonth'] = xMonthLator(payload.substring(0,8), 2);
    newState.headerDisp['4thMonth'] = xMonthLator(payload.substring(0,8), 3);
    newState.headerDisp['5thMonth'] = xMonthLator(payload.substring(0,8), 4);

    return newState;
  }
)
;
